import { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { dashboardFilterAtom } from './filterAtom';

/**
 * `dashboardFilterAtom` is persisted to localStorage so filters survive
 * closing/reopening the dashboard. Pagination, however, should always start
 * fresh on each visit, so this hook resets `activePage`/`itemsPerPage` back
 * to their defaults once on mount while preserving every other persisted
 * filter value.
 */
export const useResetPaginationOnMount = () => {
  const setFilters = useSetAtom(dashboardFilterAtom);

  useEffect(() => {
    setFilters((previousFilters) => ({
      ...previousFilters,
      activePage: 1,
      itemsPerPage: 20,
    }));
  }, [setFilters]);
};

